import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FlagIcon from "@mui/icons-material/Flag";
import PeopleIcon from "@mui/icons-material/People";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function MobileBottomNavigation({ onClose }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);

  // Update active tab based on current route
  useEffect(() => {
    if (location.pathname === "/missions") {
      setValue(1);
    } else if (location.pathname === "/persons") {
      setValue(2);
    } else {
      setValue(0);
    }
  }, [location]);

  const handleNavigation = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate("/");
        break;
      case 1:
        navigate("/missions");
        break;
      case 2:
        navigate("/persons");
        break;
      default:
        navigate("/");
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        borderTop: "1px solid #e0e0e0"
      }}
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={handleNavigation}
        sx={{
          bgcolor: "#fff",
          "& .MuiBottomNavigationAction-root": {
            color: "#999",
            "&.Mui-selected": {
              color: "#667eea"
            }
          }
        }}
      >
        <BottomNavigationAction
          label="Dashboard"
          icon={<DashboardIcon />}
        />
        <BottomNavigationAction
          label="Missies"
          icon={<FlagIcon />}
        />
        <BottomNavigationAction
          label="Personen"
          icon={<PeopleIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
}
